// Stage chrome metrics. The pills above a prototype (DrillModeToggle and
// StateSelector) sit side by side, so their height is one number rather than two
// that drift: MUI's small IconButton, standard select and the icon segments all
// measure differently, and the pills only line up if the pill says how tall it
// is. 34px of content inside 4px of padding and a 1px border.
export const PILL_H = 44;

// Loft's own interface, drawn smaller than the product it frames. Loft was being
// used with the browser zoomed out to fit its panels around the phone, which
// shrank the design too. This shrinks only the chrome: menus, drill panels,
// stage pills, the versions drawer. The prototype stays at its real size.
//
// CSS zoom scales layout as well as paint, so a panel's 100vh would come out at
// 85% of the window. Full-height chrome divides it back out with CHROME_VH.
export const CHROME_ZOOM = 0.85;
export const CHROME_VH = (vh: number) => `calc(${vh}vh / ${CHROME_ZOOM})`;
export const CHROME_VW = (vw: number) => `calc(${vw}vw / ${CHROME_ZOOM})`;
